import styled from "styled-components";
import { RiHome6Line } from "react-icons/ri";

const Container = styled.div`
    width: 100%;
    height: 35px;
    display: flex;
    background-color: ${({ isActive }) => isActive ? '#2e4a63' : 'transparent' };
    border-radius: 5px;
    align-items: center;
    cursor: pointer;
    transition: all .2s ease;
    &:hover{
        background-color: #2e4a63;
    }
    overflow: hidden;
`
const FlagSelected = styled.div`
    width: 5px;
    height: 100%;
    background-color: #ffbb00;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
`
const Icon = styled(RiHome6Line)`
    width: 20px;
    height: 20px;
    margin: auto 7px auto 15px;
    color: #fff;
`
const Title = styled.p`
    color: #fff;
    font-size: 14px;
    margin: 0;
    text-decoration: none;
`

const SidebarButton = ({ title, active }) => {
    return(
        <>
            <Container isActive={ active }>
                {active && <FlagSelected />}
                <Icon />
                <Title>{ title }</Title>
            </Container>
        </>
    )
}

export default SidebarButton;